import { render } from "./CommentMenuContext.vue?vue&type=template&id=1518ab34&scoped=true"
import script from "./CommentMenuContext.vue?vue&type=script&lang=js"
export * from "./CommentMenuContext.vue?vue&type=script&lang=js"

import "./CommentMenuContext.vue?vue&type=style&index=0&id=1518ab34&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1518ab34"]])

export default __exports__